import React from 'react';
import * as PropTypes from 'prop-types';
import { Bouton, Row, Col } from '@design-system-etat/dsfr-react';

const BoutonEtape = ({
    nameBtnSuivant,
    labelBtnSuivant,
    labelBtnPrecedent,
    actionPrecedente,
    btnSuivantDisabled,
    isLoading,
    btnPrecedentVisible,
    btnSuivantVisible,
}) => {
    return (
        <Row goutierre className="margin-top-lg">
            <Col lg={6}>
                {btnPrecedentVisible && (
                    <Bouton
                        type="button"
                        onClick={actionPrecedente}
                        name="retourEtape1"
                        label={labelBtnPrecedent}
                        niveau="secondaire"
                    />
                )}
            </Col>
            <Col lg={6} className="text-right">
                {btnSuivantVisible && (
                    <Bouton
                        name={nameBtnSuivant}
                        label={labelBtnSuivant}
                        niveau="primaire"
                        type="submit"
                        disabled={btnSuivantDisabled}
                        isLoading={isLoading}
                    />
                )}
            </Col>
        </Row>
    );
};

BoutonEtape.propTypes = {
    nameBtnSuivant: PropTypes.string,
    labelBtnSuivant: PropTypes.string,
    labelBtnPrecedent: PropTypes.string,
    actionPrecedente: PropTypes.func,
    btnSuivantDisabled: PropTypes.bool,
    isLoading: PropTypes.bool,
    btnPrecedentVisible: PropTypes.bool,
    btnSuivantVisible: PropTypes.bool,
};

BoutonEtape.defaultProps = {
    btnSuivantDisabled: true,
    isLoading: false,
    btnPrecedentVisible: true,
    btnSuivantVisible: true,
};

export default BoutonEtape;
